import RouterLink from '@/components/content/link/RouterLink';

const TAKEDOWN_TRACKER_LABEL = 'DRP Takedowns';

const SubscriptionLink = ({
  id,
  trackerName,
}: {
  id: number | null;
  trackerName: string | null;
}) => {
  const rfiLink = '/servicerequests/alert/issue';
  const takedownLink = '/drp/takedown/issue';

  const link = trackerName === TAKEDOWN_TRACKER_LABEL ? takedownLink : rfiLink;

  if (!id) {
    return null;
  }

  return <RouterLink to={`${link}/${id}`}>{id}</RouterLink>;
};

export default SubscriptionLink;
